import { createTheme } from '@mui/material/styles';
import { Theme as CustomTheme } from './themesTypes';

export const createMuiTheme = (theme: CustomTheme) => {
  return createTheme({
    typography: {
      fontFamily: ['Manrope', 'sans-serif'].join(','),
      h1: {
        fontFamily: 'Manrope',
      },
      h2: {
        fontFamily: 'Manrope',
      },
      h3: {
        fontFamily: 'Manrope',
      },
      h4: {
        fontFamily: 'Manrope',
      },
      h5: {
        fontFamily: 'Manrope',
      },
      h6: {
        fontFamily: 'Manrope',
      },
      subtitle1: {
        fontFamily: 'Manrope',
      },
      subtitle2: {
        fontFamily: 'Manrope',
      },
      body1: {
        fontFamily: 'Manrope',
      },
      body2: {
        fontFamily: 'Manrope',
      },
      button: {
        fontFamily: 'Manrope',
        textTransform: 'none',
      },
      caption: {
        fontFamily: 'Manrope',
      },
      overline: {
        fontFamily: 'Manrope',
      },
    },
    palette: {
      mode: theme.isDark ? 'dark' : 'light',
      primary: {
        main: theme.primary,
        dark: theme.primaryDark,
        light: theme.primaryLight,
      },
      secondary: {
        main: theme.secondary,
        dark: theme.secondaryDark,
        light: theme.secondaryLight,
      },
      background: {
        default: theme.background1,
        paper: theme.background2,
      },
      text: {
        primary: theme.text,
        secondary: theme.textLight,
      },
      action: {
        active: theme.fill1,
        hover: theme.fill2,
        selected: theme.fill3,
      },
      divider: theme.stroke,
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            backgroundColor: theme.background2,
            color: theme.text,
          },
          '.MuiPopover-paper': {
            padding: '0 !important',
          },
          '.MuiMenu-paper': {
            padding: '0 !important',
          },
          '.css-108ar77-MuiPaper-root-MuiMenu-paper-MuiPaper-root-MuiPopover-paper':
            {
              padding: '0 !important',
            },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            color: theme.textCTA,
            '&:hover': {
              backgroundColor: theme.primaryDark,
            },
          },
        },
      },
      MuiLink: {
        styleOverrides: {
          root: {
            color: theme.link,
          },
        },
      },
      MuiSelect: {
        styleOverrides: {
          select: {
            backgroundColor: 'transparent',
            color: theme.text,
            '& .MuiSelect-icon': {
              color: theme.text,
            },
          },
          outlined: {
            backgroundColor: theme.background2,
            color: theme.text,
            border: `1px solid ${theme.stroke}`,
            borderRadius: '8px',
            '& .MuiOutlinedInput-notchedOutline': {
              border: 'none',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              border: 'none',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              border: 'none',
            },
          },
        },
      },
      MuiMenuItem: {
        styleOverrides: {
          root: {
            backgroundColor: theme.background2,
            color: theme.text,
            '&:hover': {
              backgroundColor: theme.background3,
            },
            '&.Mui-selected': {
              backgroundColor: theme.background3,
              '&:hover': {
                backgroundColor: theme.background3,
              },
            },
          },
        },
      },
      MuiMenu: {
        styleOverrides: {
          paper: {
            padding: '0 !important',
            marginTop: '8px',
          },
          list: {
            padding: '0 !important',
          },
        },
      },
      MuiPopover: {
        styleOverrides: {
          paper: {
            backgroundColor: theme.background2,
            border: `1px solid ${theme.stroke}`,
            boxShadow: '0px 4px 24px 0px rgba(0, 0, 0, 0.15)',
            padding: '0 !important',
          },
        },
      },
    },
    // Add custom theme properties
    custom: {
      isDark: theme.isDark,
      primary: theme.primary,
      primaryDark: theme.primaryDark,
      primaryLight: theme.primaryLight,
      secondary: theme.secondary,
      secondaryDark: theme.secondaryDark,
      secondaryLight: theme.secondaryLight,
      background1: theme.background1,
      background2: theme.background2,
      background3: theme.background3,
      text: theme.text,
      textLight: theme.textLight,
      textCTA: theme.textCTA,
      link: theme.link,
      fill1: theme.fill1,
      fill2: theme.fill2,
      fill3: theme.fill3,
      stroke: theme.stroke,
    },
  });
};
